import 'web-animations-js/web-animations.min';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app.module';
import { enableProdMode} from '@angular/core'
import { environment } from '../environments/environment.prod';

    
platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error('BOOTSTRAP ERROR:', err));;

import {bootstrapApplication} from '@angular/platform-browser';

import {MyApp} from './app.component';
import {appConfig} from './app.config';

//if (environment.production) {
//  enableProdMode();
//}
//bootstrapApplication(MyApp, appConfig);


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/